// extracted by mini-css-extract-plugin
export default {"box":"company_box__9m4aX"};